<template>
  <div class="container-fluid">
    <Card back>
      <template slot="header">
        <h3><span v-if="status == 'Add'">اضافه کردن ایمیل جدید</span> <span v-else>ویرایش ایمیل</span></h3>
        <hr />
      </template>
      <template slot="content">
        <div class="row">
          <div class="col-lg-4 col-6 mt-1">
            <small id="LblDisplayName">نام ایمیل</small>
            <input type="text" class="form-control text-left" dir="ltr" v-model="data.DisplayName" />
          </div>
          <div class="col-lg-4 col-6 mt-1">
            <small id="LblSmtpHostName"> آدرس هاستSmtp</small>
            <input type="text" class="form-control text-left" dir="ltr" v-model="data.SmtpHostName" />
          </div>
          <div class="col-lg-4 col-6 mt-1">
            <small id="LblSmtpPort"> شماره پورتSmtp</small>
            <input type="number" class="form-control text-left" dir="ltr" v-model="data.SmtpPort" />
          </div>

          <div class="col-lg-4 col-6 mt-1">
            <small id="LblPopHostName">آدرس هاستPop3</small>
            <input type="text" class="form-control text-left" dir="ltr" v-model="data.PopHostName" />
          </div>

          <div class="col-lg-4 col-6 mt-1">
            <small id="LblPopPort">شماره پورت Pop3</small>
            <input type="number" class="form-control text-left" dir="ltr" v-model="data.PopPort" />
          </div>
          <div class="col-lg-4 col-6 mt-1">
            <small id="LblUserName">نام کاربری</small>
            <input type="text" class="form-control text-left" dir="ltr" v-model="data.UserName" />
          </div>
          <div class="col-lg-4 col-6 mt-1">
            <small id="LblPassword"> رمز عبور</small>
            <input type="password" class="form-control text-left" dir="ltr" v-model="data.Password" />
          </div>
          <div class="col-lg-4 col-6 mt-1"></div>
          <div class="col-lg-4 col-6 mt-1">
            <button @click="AddEmail" v-if="status == 'Add'" class="btn btn-success w-100 mt-4"><i clas="fas fa-plus"></i>اضافه کردن</button>
            <button @click="EditEmail" v-if="status == 'Edit'" class="btn btn-warning w-100 mt-4"><i clas="fas fa-حثد"></i>ویرایش</button>
          </div>
        </div>
      </template>
    </Card>
    <Card v-if="status == 'Edit'">
      <template slot="header">
        <h3>کاربران دارای دسترسی</h3>
        <hr />
      </template>
      <template slot="content">
        <div class="row">
          <div class="col-lg-4 col-12">
            <small>دادن دسترسی به کاربر</small>
            <SearchableCombo :edit="false" :grp="0" :code="null" @ResultCombo="GetResulUserId" :rownumintable="3" :action="'TblCrmCombo/GetUserDatails'" :method="'POST'" :idinput="'UserId'" :keyItem="'UserId'" :disabled="false"> </SearchableCombo>
          </div>
          <div class="col-lg-8 col-12"></div>
          <div class="col-12">
            <div class="row borde p-4 Rounded">
              <div class="col-12 p-2"><h6>کاربران دارای دسترسی به ایمیل:</h6></div>
              <div class="col-12">
                <span class="badge border m-1 p-2" v-for="(usersemail, index) in emailUserList" :key="index">
                  {{ usersemail.namFam }} &nbsp;&nbsp;
                  <i @click="RemoveUser(usersemail)" class="fas fa-times hover-danger"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
export default {
  data() {
    return {
      data: {
        Id: 55,
        SmtpHostName: '',
        PopHostName: '',
        SmtpPort: null,
        PopPort: null,
        UserName: '',
        Password: '',
        DisplayName: '',
        tblUserGrpIdInsert: this.$session.get('UserInfo').tblUserGrpId,
        tblUserGrpIdLastEdit: null,
        dateTimeInsert: '',
        dateTimeLastEdit: null,
      },
      emailUserList: [],
    }
  },
  props: ['status', 'propsemail'],
  components: { Card, SearchableCombo },
  methods: {
    EditEmail() {
      this.data.PopPort = Number(this.data.PopPort)
      this.data.SmtpPort = Number(this.data.SmtpPort)
      var DataAxios = { Method: 'POST', Action: 'Email/EditEmail', ArryfildValue: this.data }
      this.$PostData(DataAxios)
        .then((result) => {
          if (result.status == 'Success') {
            this.$mySweetDefaultTost('عملیات موفق', 'ایمیل با موفقیت ویرایش گردید ', 'success', 1000)
            this.$router.go(-1)
          } else {
            this.$mySweetDefault('عملیات ناموفق', 'مشکلی در ویرایش ایمیل بوجود آمده است. اطلاعات خود را بررسی کنید', 'warning', 1500)
          }
        })
        .catch((error) => {
          this.$mySweetDefault('خطا ', 'سیستم به حطا رسیده است با برنامه نویس تماس بگیرید', 'error', 1500)
          console.error('خطا', error)
        })
    },
    AddEmail() {
      this.data.PopPort = Number(this.data.PopPort)
      this.data.SmtpPort = Number(this.data.SmtpPort)
      var DataAxios = { Method: 'POST', Action: 'Email/AddEmail', ArryfildValue: this.data }
      this.$PostData(DataAxios)
        .then((result) => {
          if (result.status == 'Success') {
            this.$mySweetDefaultTost('عملیات موفق', 'ایمیل با موفقیت اضافه گردید ', 'success', 1000)
            this.$router.go(-1)
          } else {
            this.$mySweetDefault('عملیات ناموفق', 'مشکلی در ثبت ایمیل بوجود آمده است. اطلاعات خود را بررسی کنید', 'warning', 1500)
          }
        })
        .catch((error) => {
          this.$mySweetDefault('خطا ', 'سیستم به حطا رسیده است با برنامه نویس تماس بگیرید', 'error', 1500)
          console.error('خطا', error)
        })
    },
    GetResulUserId(data) {
      if (data.id != null) {
        var DataAxios = {
          Method: 'POST',
          Action: 'Email/AddUserEmail',
          ArryfildValue: { Id: 55, tblEmailSettingId: this.data.Id, tblUserid: data.id, dateTimeInsert: '', dateTimeLastEdit: null, tblUserGrpIdLastEdit: null, tblUserGrpIdInsert: this.$session.get('UserInfo').tblUserGrpId },
        }
        this.$PostData(DataAxios)
          .then((result) => {
            if (result.status == 'Success') {
              this.emailUserList = result.data
            } else {
              this.$mySweetDefault('عملیات ناموفق', result.msg, 'warning', 1500)
            }
          })
          .catch((error) => {
            this.$mySweetDefault('خطا ', 'سیستم به حطا رسیده است با برنامه نویس تماس بگیرید', 'error', 1500)
            console.error('خطا', error)
          })
      }
    },
    RemoveUser(data) {
      var DataAxiosDelete = { Method: 'POST', Action: 'Email/DeleteUsertEmail', ArryfildValue: data }
      this.$PostData(DataAxiosDelete)
        .then((result) => {
          if (result.status == 'Success') {
            this.emailUserList = result.data
          } else {
            this.$mySweetDefault('عملیات ناموفق', result.msg, 'warning', 1500)
          }
        })
        .catch((error) => {
          this.$mySweetDefault('خطا ', 'سیستم به حطا رسیده است با برنامه نویس تماس بگیرید', 'error', 1500)
          console.error('خطا', error)
        })
    },
  },
  created() {
    if (this.status == 'Edit') {
      var DataAxiosGetuseEmail = { Method: 'POST', Action: 'Email/GetUserEmail', ArryfildValue: { Id: this.propsemail.Id } }
      this.$PostData(DataAxiosGetuseEmail).then((result) => {
        this.emailUserList = result
      })
      this.data = JSON.parse(JSON.stringify(this.propsemail))
      this.data.DisplayName = this.data.DisplayName.trim()
      this.data.SmtpHostName = this.data.SmtpHostName.trim()
      this.data.PopHostName = this.data.PopHostName.trim()
      this.data.Password = this.data.Password.trim()
      this.data.UserName = this.data.UserName.trim()
    }
  },
}
</script>
<style scoped>
.badge {
  font-weight: normal !important;
  background: var(--sidebar-bg-color);
}

.badge:hover {
  cursor: pointer;
  font-size: medium;
  font-weight: bold;
  transform: 1s !important;
}
</style>
